import { React, Fragment, memo, useEffect } from 'react'
import {
  HeadingText,
  Button,
  BodyText,
  DeleteIcon,
  InformationSmIcon,
  ClockSmIcon,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PRIVACY_HOME } from '../../../constants/constants'
import serverData from '../../../utils/server-data'
import { fptiCustomClick, fptiCustomSetup } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import PreventDuplicateRequestsCards from './preventDuplicateRequestsCards'

const preventDuplicateErasureFpti = DATAPRIVACY_FPTI.PREVENT_DUPLICATE_ERASURE

const preventDuplicateErasure = memo((props) => {
  const { unResolvedError = false } = serverData
  useEffect(() => {
    if (unResolvedError) {
      fptiCustomSetup(
        preventDuplicateErasureFpti.PREVENT_DUPLICATE_ERASURE_UN_RESOLVED,
      )
    } else {
      fptiCustomSetup(
        preventDuplicateErasureFpti.PREVENT_DUPLICATE_ERASURE_IN_PROGRESS,
      )
    }
  }, [])

  const handleContinueClick = (event) => {
    event.preventDefault()
    fptiCustomClick(
      preventDuplicateErasureFpti.PREVENT_DUPLICATE_ERASURE_MAKE_REQUEST,
    )
    props.updatePreventRequest(false)
  }

  const handleCancelClick = (event) => {
    event.preventDefault()
    location.href = PRIVACY_HOME
  }

  return (
    <Fragment>
      <section className="text-center">
        {unResolvedError ? (
          <div className="icon-container2">
            <DeleteIcon size="lg" />
            <InformationSmIcon
              size="sm"
              color="sysColorWarningAlt"
              className="icon2"
            />
          </div>
        ) : (
          <div className="icon-container2">
            <DeleteIcon size="lg" color="sysColorAccent1Main" />
            <ClockSmIcon
              size="sm"
              color="sysColorWarningMain"
              className="icon2"
            />
          </div>
        )}
      </section>

      {unResolvedError ? (
        <section>
          <PreventDuplicateRequestsCards />
          <div className="requestForm-row flex-row-alignment ">
            <InformationSmIcon />
            <BodyText>
              <Message id="dataErasure.preventrequset.error_info" />
            </BodyText>
          </div>

          <div className="flex-center-alignment requestForm-section-row">
            <Button id="submitBtn" onClick={handleContinueClick}>
              <Message id="dataErasure.preventrequset.newrequestbtn" />
            </Button>
            <Button
              tertiary
              onClick={handleCancelClick}
              className="requestForm-section-desc"
            >
              <Message id="dataErasure.preventrequset.cancelbtn" />
            </Button>
          </div>
        </section>
      ) : (
        <section className="text-center">
          <HeadingText size="sm" className="requestForm-row">
            <Message id="dataErasure.preventrequset.inprogress_header" />
          </HeadingText>
          <BodyText className="requestForm-row">
            <Message id="dataErasure.preventrequest.inprogress_desc" />
          </BodyText>
        </section>
      )}
    </Fragment>
  )
})

preventDuplicateErasure.displayName = 'preventDuplicateErasure'
export default preventDuplicateErasure
